<template lang="pug">

  #video-component.aspect-ratio-box

    .aspect-ratio-box-inside
      button( v-if="buttonVisible" @click="onClick" :aria-label="lang_en['home-aria-label-youtube-play-button']").button
        .poster(ref="background" :style="styleObj")
        .play-btn-wrap
          play-btn-svg

      transition( name="fade")
        .youtubeContainer(v-show="!buttonVisible")
          youtube(
            ref="youtube"
            @playing="playing"
            @paused="stopped"
            @ended="stopped"
            :wmode="'transparent'"
            :resize="true"
            :video-id="src"
            :player-vars="playerVars"
            )

</template>

<script>

import gsap from 'gsap'
import { mapState, mapMutations } from 'vuex'
import { MODAL_STATES, PATHS, EVENTS } from 'src/config/app'
import PlayBtnSvg from 'src/assets/svgs/play_button.svg'
import Communicator from '@/helpers/Communicator'

export default {

  props: {
    poster: String,
    src: String,
    show: Boolean
  },

  data() {
    return {
      buttonVisible: true,
      delayPassed: false,
      playerVars: {
        //fitParent: true
        resize: true,
        showinfo: 0,
        modestbranding: 0,
        wmode: 'transparent'
      }
    }
  },

  computed: {

    ...mapState('app', [
      'video_overlay'
    ]),

    videoVisible() {
      return this.buttonVisible
    },

    player() {
      return this.$refs.youtube.player
    },

    styleObj() {
      return {
        backgroundImage : `url("${this.poster}")`
      }
    }
  },

  components: {
    PlayBtnSvg
  },

  mounted(){
    gsap.delayedCall(1.5, this.onDelay)
  },

  beforeDestroy(){
    gsap.killTweensOf(this.onDelay)
    gsap.killTweensOf(this.onStopDelay)
  },

  methods: {

    ...mapMutations('app',[ 'setModalState', 'setVideoModalSrc']),

    onClick(){
      gsap.killTweensOf(this.onStopDelay)
      //this.setVideoModalSrc(this.src)
      //this.setModalState(MODAL_STATES.VIDEO)
      this.buttonVisible = false
      Communicator.trigger(EVENTS.STOP_RENDER)
      this.player.playVideo()
    },

    onDelay(){
      this.delayPassed = true
    },

    onStopDelay(){
      Communicator.trigger(EVENTS.START_RENDER)
    },

    playing(){
      Communicator.trigger(EVENTS.STOP_RENDER)
    },

    stopped(){
      gsap.delayedCall(0.5, this.onStopDelay)
    },

    enter(){
    },

    leave(){
      Communicator.trigger(EVENTS.START_RENDER)
      this.buttonVisible = true
    }
  }
}

</script>

<style lang="sass">
@import "src/styles/common.sass"

#video-component
  position: relative
  width: 63.8rem 
  height: 0
  overflow: hidden
  padding-top: 33%
  position: relative

  @media all and (max-width: $bp-mobile)
    padding-top: 56.4%
    width: 100%

  iframe
    width: 100%
    height: 100%

  .button
    &:hover,
    &:focus
      .poster
        transition: opacity 0.2s ease-out
        opacity: 0.3  
 

  .aspect-ratio-box-inside
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    // background: rgba(255,255,255,0.1) 
    background-size: 150%
    background-image: url('/images/loader-background.jpg')

    .youtubeContainer
      width: 100%
      height: 100%


    .poster
      +full()
      transition: opacity 0.5s ease-in-out
      background-size: cover
      background-position: center

    .play-btn-wrap
      +full()
      +flex-center()

      svg
        width: 80px
        height: 80px

</style>
